(function (ws) {
    'use strict';

    ws.views.mdmDynamicSearchTableShipto = ws.views.simpleTable.extend({

        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'click .select-trillium-address': 'trilliumAddressSelected',
            'click .select-shipto-from-result': 'shiptoAddressSelected'
        }),

        /**
         * Initialize override
         */
        initialize: function () {
            this.accountNameSelected = '';
            this.$table = this.$('#mdm-table-shipTo');
            this.$tableTrillium = this.$('#trillium-table-shipTo');
            this.orderNumber = $('.order-meta-data').data('order-number');
            this.quoteNumber = $("input[name='quoteID']").val();

            ws.views.simpleTable.prototype.initialize.call(this);
            this.$table.hide();
            this.$tableTrillium.hide();
            this.eventAgg.on('mdmDynamicSearchShipTo', this.mdmSearch, this);
            this.eventAgg.on('trilliumDynamicSearchShipTo', this.trilliumSearch, this);
            this.eventAgg.on('destroyTableShipTo', this.destroyTable, this);
            this.eventAgg.on('shiptoAddressSelected', this.shiptoAddressSelected, this);
            this.url = isOrderEntrySite ?  globals.path.api.orderentry.dynamicMdmSearchApi.replace('{orderNumber}', this.orderNumber) : globals.path.api.quoting.dynamicMdmSearchApi.replace('{quoteId}', this.quoteNumber);
            this.urlTrillium = isOrderEntrySite ? globals.path.api.orderentry.trilliumSearchApi : globals.path.api.quoting.trilliumSearchApi;
            this.isQuotingShipto = false;
        },

        trilliumAddressSelected: function (e) {
            let address = JSON.parse(e.target.dataset.address);
            address.accountName = this.accountNameSelected;
            let triggerName = this.isQuotingShipto ? 'dynamicPopupDisplaySettingsQuoting' : 'dynamicPopupDisplaySettings';

            if (!isOrderEntrySite && !isQuotingSite) {
                triggerName = 'dynamicPopupDisplaySettingsSHIPTO';
            }

            this.eventAgg.trigger(triggerName, false, address);
        },

        shiptoAddressSelected: function (e) {
            this.destroyTable();
            this.eventAgg.trigger('submitShippingForm', false, 'result', JSON.parse(e.target.dataset.address));
            globals.disableApp();
        },

        mdmSearch: function (parentClassName, id) {
            $('.comp-mdm-dynamic-search').hide();
            this.$table.hide();
            globals.disableApp();
            let data = {};
            this.isQuotingShipto = false;

            if (parentClassName === 'newAddressContainerPopUp') {
                parentClassName = '.shipping-section #newAddressContainer';
                data = {
                    city: $(`${parentClassName} #city`).val(),
                    accountName: $(`${parentClassName} #companyName`).val(),
                    country: $(`${parentClassName} #country`).val(),
                    addressLine1: $(`${parentClassName} #line1`).val(),
                    addressLine2: $(`${parentClassName} #line2`).val(),
                    addressLine3: $(`${parentClassName} #line3`).val(),
                    addressLine4: $(`${parentClassName} #line4`).val(),
                    locality: $(`${parentClassName} #line5`).val(),
                    state: $(`${parentClassName} #state`).val(),
                    contactPhoneNumber: $(`${parentClassName} #phone`).val(),
                    zipCode: $(`${parentClassName} #zipCode`).val(),
                    poBoxNumber:  $(`${parentClassName} #poBoxNumber`).val(),
                    type: 'SHIPTO'
                };

                $(`${parentClassName} :input`).val('');
                parentClassName = 'comp-ship-to-account-lookup';

                $(`.${parentClassName} #country`).val(data.country ? data.country : '');
                $(`.${parentClassName} #country`).change();
                $(`.${parentClassName} #accountName`).val(data.accountName ? data.accountName : '');
                $(`.${parentClassName} #addressLine1`).val(data.addressLine1 ? data.addressLine1 : '');
                $(`.${parentClassName} #addressLine2`).val(data.addressLine2 ? data.addressLine2 : '');
                $(`.${parentClassName} #addressLine3`).val(data.addressLine3 ? data.addressLine3 : '');
                $(`.${parentClassName} #addressLine4`).val(data.addressLine4 ? data.addressLine4 : '');
                $(`.${parentClassName} #addressLine5`).val(data.locality ? data.locality : '');
                $(`.${parentClassName} #city`).val(data.city ? data.city : '');
                $(`.${parentClassName} #poBoxNumber`).val(data.poBoxNumber ? data.poBoxNumber : '');
                $(`.${parentClassName} #zipCode`).val(data.zipCode ? data.zipCode : '');
                $(`.${parentClassName} #state`).val(data.state ? data.state : '');

            } else if (parentClassName === 'newAddressContainer') {
                data = {
                    city: $(`#${parentClassName} #city`).val(),
                    accountName: $(`#${parentClassName} #companyName`).val(),
                    country: $(`#${parentClassName} #country`).val(),
                    addressLine1: $(`#${parentClassName} #line1`).val(),
                    addressLine2: $(`#${parentClassName} #line2`).val(),
                    addressLine3: $(`#${parentClassName} #line3`).val(),
                    addressLine4: $(`#${parentClassName} #line4`).val(),
                    locality: $(`#${parentClassName} #line5`).val(),
                    state: $(`#${parentClassName} #state`).val(),
                    contactPhoneNumber: $(`#${parentClassName} #phone`).val(),
                    zipCode: $(`#${parentClassName} #zipCode`).val(),
                    poBoxNumber:  $(`#${parentClassName} #poBoxNumber`).val(),
                    type: 'SHIPTO'
                };

                this.isQuotingShipto = true;
                parentClassName = 'comp-quote-shipping';
            } else {
                $(`.${parentClassName} .addAddressForm`).serializeArray().map(function (x) {
                    data[x.name] = x.value;
                });
            }

            $(`.${parentClassName} .noResults`).addClass('hide');
            this.$('.serverResponseError').html('').addClass('hide').hide();
            $('.trilliumPopupError').hide();
            let dataQuery = {};
            $(`.${parentClassName} .addAddressForm`).serializeArray().map(function (x) {
                dataQuery[x.name] = x.value;
            });
            if (isOrderEntrySite) {
                this.$table.DataTable().destroy();
            }

            this.$table.DataTable({
                ordering: false,
                searching: false,
                responsive: false,
                bFilter: false,
                serverSide: true,
                ajax: (data, callback) => {
                    dataQuery.pageSize = data.length;
                    dataQuery.currentPage = ((data.length + data.start) / data.length) - 1;
                    $.get(this.url + '?' + new URLSearchParams(dataQuery).toString(), {},
                        (response) => {
                            globals.disableApp();
                            if (!response.error && response.suggested && response.suggested.length > 0) {
                                this.$table.show();
                                $('.comp-mdm-dynamic-search').show();
                                globals.enableApp();
                                this.$('.serverResponseError').html('').addClass('hide').hide();
                                callback({
                                    recordsTotal: response.paginationResponse.totalNumberOfResults,
                                    recordsFiltered: response.paginationResponse.totalNumberOfResults,
                                    data: response.suggested
                                });
                                if (!isQuotingSite && !isOrderEntrySite && id) {
                                    this.$('.help-text').removeClass('hide');
                                }
                            } else if (response.error) {
                                this.$table.hide();
                                $('.comp-mdm-dynamic-search').hide();
                                this.$('.serverResponseError').html(response.errors[0].message).removeClass('hide').show();
                                globals.enableApp();
                            } else {
                                this.$table.hide();
                                $('.comp-mdm-dynamic-search').hide();
                                $(`.${parentClassName} .noResults`).removeClass('hide');
                                globals.enableApp();
                            }
                        });
                },

                columnDefs: [
                    {
                        targets: 3,
                        className: 'align-center',
                        visible: $('#enableMDMTrilliumAddressValidation').val() === 'true' ? true : false
                    }
                ],
                columns: [
                    { data: 'sapId' },
                    { data: 'accountName' },
                    { data: null,
                        render: function(data, type, full) {
                            let regionCode = $('#qut-region').val() === 'EMEA' ? (full.regionData ? full.regionData.name : '') : (full.state ? full.state : '');
                            return (full.addressLine1 ? full.addressLine1 : '') + ', ' + (full.town ? full.town : '') + ', ' + regionCode + ', ' + (full.zipCode ? full.zipCode : '') + ', ' + (full.country ? full.country.isocode : '');
                        }
                    },
                    { data: null,
                        render: function(data, type, full) {
                            if (full.trilliumResponse && full.trilliumResponse !== ' ') {
                                return "<span style='font-size:20;color: green;'>&#10004;</span>";
                            } else {
                                return '';
                            }
                        }
                    },
                    { data: null,
                        render: function(data, type, full) {
                            let selectButton = isQuotingSite && $('#addressBookChanges').val() === 'true' ? 'select-shipto-from-result' : 'select-account';
                            return '<button class="' + selectButton + '" data-type="SHIPTO" data-address=\'' + JSON.stringify(full).replace(/'/g, '&#39;')  + '\'>Select Address</button>';
                        }
                    }
                ]

            });

        },

        trilliumSearch: function (parentClassName, id) {
            this.$tableTrillium.hide();
            let data = {};

            if (parentClassName === 'newAddressContainer') {
                data = {
                    city: $(`#${parentClassName} #city`).val(),
                    accountName: $(`#${parentClassName} #companyName`).val(),
                    country: $(`#${parentClassName} #country`).val(),
                    addressLine1: $(`#${parentClassName} #line1`).val(),
                    addressLine2: $(`#${parentClassName} #line2`).val(),
                    addressLine3: $(`#${parentClassName} #line3`).val(),
                    addressLine4: $(`#${parentClassName} #line4`).val(),
                    locality: $(`#${parentClassName} #line5`).val(),
                    state: $(`#${parentClassName} #state`).val(),
                    contactPhoneNumber: $(`#${parentClassName} #phone`).val(),
                    zipCode: $(`#${parentClassName} #zipCode`).val(),
                    poBoxNumber:  $(`#${parentClassName} #poBoxNumber`).val(),
                    type: 'SHIPTO'
                };

                parentClassName = 'comp-quote-shipping';
                $(`#${parentClassName} .noResults`).addClass('hide');
            } else {
                $(`.${parentClassName} .addAddressForm`).serializeArray().map(function (x) {
                    data[x.name] = x.value;
                });

                $(`.${parentClassName} .noResults`).addClass('hide');
            }

            this.$('.serverResponseError').html('').addClass('hide').hide();
            globals.disableApp();
            let url = '';

            if (!isOrderEntrySite && !isQuotingSite) {
                url = globals.path.api.westcon.trilliumSearchApi;
            } else {
                url = this.urlTrillium + '/' + id;
            }

            this.accountNameSelected = data.accountName;
            $.get(url, data, (response) => {
                this.$tableTrillium.dataTable().fnClearTable();
                this.$tableTrillium.DataTable().destroy();
                globals.enableApp();
                if (!response.error && response.suggested && response.suggested.length > 0) {
                    this.$tableTrillium.show();
                    this.$tableTrillium.dataTable({
                        searching: false,
                        responsive: false,
                        aaData: response.suggested,
                        aoColumns: [
                            { mData: null,
                                mRender: function(data, type, full) {
                                    let regionCode = $('#qut-region').val() === 'EMEA' ? (full.regionData ? full.regionData.name : '') : (full.state ? full.state : '');
                                    return (full.addressLine1 ? full.addressLine1 : '') + ', ' + (full.town ? full.town : '') + ', ' + regionCode + ', ' + (full.zipCode ? full.zipCode : '') + ', ' + (full.country ? full.country.isocode : '');
                                }
                            },
                            { mData: null,
                                mRender: function(data, type, full) {
                                    return '<button class="select-trillium-address" data-address=\'' + JSON.stringify(full).replace(/'/g, '&#39;')  + '\'>Select Address</button>';
                                }
                            }
                        ]
                    });
                } else if (response.error) {
                    this.$table.hide();
                    this.$('.serverResponseError').html(response.errors[0].message).removeClass('hide').show();
                } else {
                    this.$tableTrillium.hide();
                    $(`#${parentClassName} .noResults`).removeClass('hide');
                }
            });
        },

        destroyTable: function() {
            //this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            this.$table.hide();

            this.$tableTrillium.dataTable().fnClearTable();
            this.$tableTrillium.DataTable().destroy();
            this.$tableTrillium.hide();
        },

        paginate: function () {

        }
    });
}(westcon));
